import { render, staticRenderFns } from "./vGestionSolicitud.vue?vue&type=template&id=6a0b6fce&scoped=true&"
import script from "./vGestionSolicitud.vue?vue&type=script&lang=js&"
export * from "./vGestionSolicitud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0b6fce",
  null
  
)

export default component.exports